// HACK: This might not always match.
// We do this because retour doesn't currently let us query by site handle.
// See: https://github.com/nystudio107/craft-retour/issues/129
export default {
  amanaliving: 2,
  careers: 1,
  training: 3,
};
